import { IHistoryResponse, ILoadAccountHistoryStartPayload } from '../modules/Account/types/accountActions.t';
import {
    ADD_AB_TEST_TO_IS_USED_QUEUE,
    APP_INIT_FAILURE,
    APP_INIT_START,
    APP_INIT_SUCCESS,
    APP_LOG,
    CLOSE_MODAL,
    COMPLETE_LEADERBOARD_ONBOARDING_SUCCESS,
    COMPLETE_ONBOARDING_FAILURE,
    COMPLETE_ONBOARDING_START,
    COMPLETE_ONBOARDING_SUCCESS,
    DELETE_PROFILE_FAILURE,
    DELETE_PROFILE_START,
    DELETE_PROFILE_SUCCESS,
    LOAD_ACCOUNT_HISTORY_FAILURE,
    LOAD_ACCOUNT_HISTORY_INFO_FAILURE,
    LOAD_ACCOUNT_HISTORY_INFO_START,
    LOAD_ACCOUNT_HISTORY_INFO_SUCCESS,
    LOAD_ACCOUNT_HISTORY_START,
    LOAD_ACCOUNT_HISTORY_SUCCESS,
    LOAD_ACCOUNT_TRADE_INFO_FAILURE,
    LOAD_ACCOUNT_TRADE_INFO_START,
    LOAD_ACCOUNT_TRADE_INFO_SUCCESS,
    LOG_ACTION,
    LOG_APPSFLYER_ACTION,
    LOG_PAYMENT_OPEN_APPSFLYER_ACTION,
    OPEN_MODAL,
    RESET_FORM_ERROR,
    SEND_FACEBOOK_EVENT_ACTION,
    SEND_REQUEST_FEEDBACK_FAILURE,
    SEND_REQUEST_FEEDBACK_START,
    SEND_REQUEST_FEEDBACK_SUCCESS,
    SET_APP_INIT_DATA,
    SET_IS_FIRST_LOGIN,
    SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE,
    SET_LANG_DATA_ACTION,
    SET_RECENT_DONE,
    SET_REQUEST_FEEDBACK,
    SET_USER_SELECTED_ACCOUNT_CODE,
    SET_ZENDESK_CONFIG_ACTION,
    TOGGLE_IS_ONE_CLICK_TRADING_ON,
    UPDATE_AB_TEST_IS_USED_START,
    UPDATE_ACCOUNT_ACTION,
    UPDATE_LANG_ACTION,
    USER_PROMOCODE_APPLY_FAILURE,
    USER_PROMOCODE_APPLY_START,
    USER_PROMOCODE_APPLY_SUCCESS,
    USER_PROMOCODE_REMOVE_FAILURE,
    USER_PROMOCODE_REMOVE_START,
    USER_PROMOCODE_REMOVE_SUCCESS,
    USER_UPDATE_FAILURE,
    USER_UPDATE_PASSWORD_FAILURE,
    USER_UPDATE_PASSWORD_START,
    USER_UPDATE_PASSWORD_SUCCESS,
    USER_UPDATE_START,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_USERNAME_CLEAR,
    USER_UPDATE_USERNAME_FAILURE,
    USER_UPDATE_USERNAME_START,
    USER_UPDATE_USERNAME_SUCCESS,
} from './appConstants';
import createAction, { createClearAction } from './createAction';
import {
    IAccountHistoryInfo,
    IAppLogAction,
    ILoadAccountInfoPayload,
    ILogAction,
    ILogAppsflyerAction,
    ILogPaymentOpenAppsflyerAction,
    IOpenModalPayload,
    ISetAppInitDataPayload,
    IUpdateLangActionPayload,
    IUpdateUsernameSuccessPayload,
    IUpdateUsernameActionPayload,
    IUser,
    IUserAccount, IUsernameSuggestionFailurePayload,
    IUserPromocodePayload,
    IUserUpdateActionPayload,
    TAbTestNames,
} from './types/appActions.t';
import type { IAccountCode } from './types/appReducer.t';
import { IRequestFeedback } from '../modules/RequestFeedback/requestFeedback.t';
import { IZendeskConfig } from "../modules/Zendesk/zendesk.t";
import { ILangItem } from '../providers/LangProvider/langProvider.t';
import { ISendFacebookEventPayload } from "../utils/sendFacebookEvent";

export const appInitAction = () => createClearAction<typeof APP_INIT_START>(APP_INIT_START);
export const appInitSuccess = () => createClearAction<typeof APP_INIT_SUCCESS>(APP_INIT_SUCCESS);
export const appInitFailure = (payload?: unknown) => createClearAction<typeof APP_INIT_FAILURE>(APP_INIT_FAILURE, payload);
export const setAppInitDataAction = (payload: ISetAppInitDataPayload) => createAction<typeof SET_APP_INIT_DATA, ISetAppInitDataPayload>(SET_APP_INIT_DATA, payload);

export const appLog = (payload: IAppLogAction) => createAction<typeof APP_LOG, IAppLogAction>(APP_LOG, payload);
export const logAction = (payload?: ILogAction) => createAction<typeof LOG_ACTION, ILogAction | undefined>(LOG_ACTION, payload);
export const logAppsflyerAction = (payload: ILogAppsflyerAction) => createAction<typeof LOG_APPSFLYER_ACTION, ILogAppsflyerAction>(LOG_APPSFLYER_ACTION, payload);
export const logPaymentOpenAppsflyerAction = (payload: ILogPaymentOpenAppsflyerAction) => createAction<typeof LOG_PAYMENT_OPEN_APPSFLYER_ACTION, ILogPaymentOpenAppsflyerAction>(LOG_PAYMENT_OPEN_APPSFLYER_ACTION, payload);

export const openModalAction = (payload: IOpenModalPayload) => createAction<typeof OPEN_MODAL, IOpenModalPayload>(OPEN_MODAL, payload);
export const closeModalAction = (payload?: unknown) => createClearAction<typeof CLOSE_MODAL>(CLOSE_MODAL, payload);

export const userUpdateAction = (payload: IUserUpdateActionPayload) => createAction<typeof USER_UPDATE_START, IUserUpdateActionPayload>(USER_UPDATE_START, payload);
export const userUpdateSuccess = (payload: Partial<IUser>) => createAction<typeof USER_UPDATE_SUCCESS, Partial<IUser>>(USER_UPDATE_SUCCESS, payload);
export const userUpdateFailure = (payload?: unknown) => createClearAction<typeof USER_UPDATE_FAILURE>(USER_UPDATE_FAILURE, payload);

export const setZendeskConfigAction = (payload: Partial<IZendeskConfig>) =>
    createAction<typeof SET_ZENDESK_CONFIG_ACTION, Partial<IZendeskConfig>>(SET_ZENDESK_CONFIG_ACTION, payload);

export interface IUserUpdatePassword {
    password: string;
    passwordNew: string;
    passwordNew2: string;
    callback: () => void;
}

export const userUpdatePasswordAction = (payload?: IUserUpdatePassword) => createAction<typeof USER_UPDATE_PASSWORD_START, IUserUpdatePassword | undefined>(USER_UPDATE_PASSWORD_START, payload);
export const userUpdatePasswordSuccess = (payload?: unknown) => createClearAction<typeof USER_UPDATE_PASSWORD_SUCCESS>(USER_UPDATE_PASSWORD_SUCCESS, payload);
export const userUpdatePasswordFailure = (payload: string | null) => createAction<typeof USER_UPDATE_PASSWORD_FAILURE, string | null>(USER_UPDATE_PASSWORD_FAILURE, payload);

export const userUpdateUsernameAction = (payload?: IUpdateUsernameActionPayload) => createAction<typeof USER_UPDATE_USERNAME_START, IUpdateUsernameActionPayload | undefined>(USER_UPDATE_USERNAME_START, payload);
export const userUpdateUsernameSuccess = (payload?: IUpdateUsernameSuccessPayload) => createAction<typeof USER_UPDATE_USERNAME_SUCCESS, IUpdateUsernameSuccessPayload | undefined>(USER_UPDATE_USERNAME_SUCCESS, payload);
export const userUpdateUsernameFailure = (payload: any) => createAction<typeof USER_UPDATE_USERNAME_FAILURE, IUsernameSuggestionFailurePayload | string | null>(USER_UPDATE_USERNAME_FAILURE, payload);
export const userUpdateUsernameClearAction = (payload?: unknown) => createClearAction<typeof USER_UPDATE_USERNAME_CLEAR>(USER_UPDATE_USERNAME_CLEAR, payload);

export const userPromocodeApplyAction = (payload: IUserPromocodePayload) => createAction<typeof USER_PROMOCODE_APPLY_START, IUserPromocodePayload>(USER_PROMOCODE_APPLY_START, payload);
export const userPromocodeApplySuccess = (payload?: unknown) => createClearAction<typeof USER_PROMOCODE_APPLY_SUCCESS>(USER_PROMOCODE_APPLY_SUCCESS, payload);
export const userPromocodeApplyFailure = (payload?: unknown) => createClearAction<typeof USER_PROMOCODE_APPLY_FAILURE>(USER_PROMOCODE_APPLY_FAILURE, payload);

export const userPromocodeRemoveAction = (payload?: unknown) => createClearAction<typeof USER_PROMOCODE_REMOVE_START>(USER_PROMOCODE_REMOVE_START, payload);
export const userPromocodeRemoveSuccess = (payload?: unknown) => createClearAction<typeof USER_PROMOCODE_REMOVE_SUCCESS>(USER_PROMOCODE_REMOVE_SUCCESS, payload);
export const userPromocodeRemoveFailure = (payload?: unknown) => createClearAction<typeof USER_PROMOCODE_REMOVE_FAILURE>(USER_PROMOCODE_REMOVE_FAILURE, payload);

export const setIsFirstLoginAction = (payload: boolean) => createAction<typeof SET_IS_FIRST_LOGIN, boolean>(SET_IS_FIRST_LOGIN, payload);

export const completeOnboardingAction = (payload?: unknown) => createClearAction<typeof COMPLETE_ONBOARDING_START>(COMPLETE_ONBOARDING_START, payload);
export const completeOnboardingSuccess = (payload?: unknown) => createClearAction<typeof COMPLETE_ONBOARDING_SUCCESS>(COMPLETE_ONBOARDING_SUCCESS, payload);
export const completeOnboardingFailure = (payload?: unknown) => createClearAction<typeof COMPLETE_ONBOARDING_FAILURE>(COMPLETE_ONBOARDING_FAILURE, payload);

export const resetFormErrorAction = (payload?: unknown) => createClearAction<typeof RESET_FORM_ERROR>(RESET_FORM_ERROR, payload);

export type IUpdateAbTestIsUsedActionPayload = TAbTestNames[];

export const updateAbTestIsUsedAction = (payload?: IUpdateAbTestIsUsedActionPayload) =>
    createAction<typeof UPDATE_AB_TEST_IS_USED_START, IUpdateAbTestIsUsedActionPayload>(UPDATE_AB_TEST_IS_USED_START, payload);
export const addAbTestToIsUsedQueueAction = (payload: TAbTestNames) => createAction<typeof ADD_AB_TEST_TO_IS_USED_QUEUE, TAbTestNames>(ADD_AB_TEST_TO_IS_USED_QUEUE, payload);

export const loadAccountTradeInfoAction = (payload: string) => createAction<typeof LOAD_ACCOUNT_TRADE_INFO_START, string>(LOAD_ACCOUNT_TRADE_INFO_START, payload);
export const loadAccountTradeInfoSuccess = (payload: ILoadAccountInfoPayload) => createAction<typeof LOAD_ACCOUNT_TRADE_INFO_SUCCESS, ILoadAccountInfoPayload>(LOAD_ACCOUNT_TRADE_INFO_SUCCESS, payload);
export const loadAccountTradeInfoFailure = (payload: ILoadAccountInfoPayload) => createAction<typeof LOAD_ACCOUNT_TRADE_INFO_FAILURE, ILoadAccountInfoPayload>(LOAD_ACCOUNT_TRADE_INFO_FAILURE, payload);

export const setRecentDoneAction = (payload?: string) => createAction<typeof SET_RECENT_DONE, string | undefined>(SET_RECENT_DONE, payload);
export const setUserSelectedAccountCode = (payload: IAccountCode) => createAction<typeof SET_USER_SELECTED_ACCOUNT_CODE, IAccountCode>(SET_USER_SELECTED_ACCOUNT_CODE, payload);

export const setIsOpenMobileAppBannerVisibleAction = (payload: boolean) => createAction<typeof SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE, boolean>(SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE, payload);

export const loadAccountHistoryAction = (payload: ILoadAccountHistoryStartPayload) => createAction<typeof LOAD_ACCOUNT_HISTORY_START, ILoadAccountHistoryStartPayload>(LOAD_ACCOUNT_HISTORY_START, payload);
export const loadAccountHistorySuccess = (payload: IHistoryResponse) => createAction<typeof LOAD_ACCOUNT_HISTORY_SUCCESS, IHistoryResponse>(LOAD_ACCOUNT_HISTORY_SUCCESS, payload);
export const loadAccountHistoryFailure = (payload?: string) => createAction<typeof LOAD_ACCOUNT_HISTORY_FAILURE, string>(LOAD_ACCOUNT_HISTORY_FAILURE, payload);

export const loadAccountHistoryInfoAction = (payload?: unknown) => createClearAction<typeof LOAD_ACCOUNT_HISTORY_INFO_START>(LOAD_ACCOUNT_HISTORY_INFO_START, payload);
export const loadAccountHistoryInfoSuccess = (payload: IAccountHistoryInfo) => createAction<typeof LOAD_ACCOUNT_HISTORY_INFO_SUCCESS, IAccountHistoryInfo>(LOAD_ACCOUNT_HISTORY_INFO_SUCCESS, payload);
export const loadAccountHistoryInfoFailure = (payload?: unknown) => createClearAction<typeof LOAD_ACCOUNT_HISTORY_INFO_FAILURE>(LOAD_ACCOUNT_HISTORY_INFO_FAILURE, payload);

export const setRequestFeedbackAction = (payload: boolean) => createAction<typeof SET_REQUEST_FEEDBACK, boolean>(SET_REQUEST_FEEDBACK, payload);
export const sendRequestFeedbackAction = (payload: IRequestFeedback) => createAction<typeof SEND_REQUEST_FEEDBACK_START, IRequestFeedback>(SEND_REQUEST_FEEDBACK_START, payload);
export const sendRequestFeedbackSuccess = () => createClearAction<typeof SEND_REQUEST_FEEDBACK_SUCCESS>(SEND_REQUEST_FEEDBACK_SUCCESS);
export const sendRequestFeedbackFailure = (payload?: string) => createAction<typeof SEND_REQUEST_FEEDBACK_FAILURE, string>(SEND_REQUEST_FEEDBACK_FAILURE, payload);

export const updateAccountAction = (payload: Partial<IUserAccount>) => createAction<typeof UPDATE_ACCOUNT_ACTION, Partial<IUserAccount>>(UPDATE_ACCOUNT_ACTION, payload);

export const deleteProfileAction = (payload: string) => createAction<typeof DELETE_PROFILE_START, string>(DELETE_PROFILE_START, payload);
export const deleteProfileSuccess = () => createClearAction<typeof DELETE_PROFILE_SUCCESS>(DELETE_PROFILE_SUCCESS);
export const deleteProfileFailure = (payload: string) => createAction<typeof DELETE_PROFILE_FAILURE, string>(DELETE_PROFILE_FAILURE, payload);

export const updateLangAction = (payload?: IUpdateLangActionPayload) => createAction<typeof UPDATE_LANG_ACTION, IUpdateLangActionPayload>(UPDATE_LANG_ACTION, payload);
export const setLangDataAction = (payload: ILangItem) => createAction<typeof SET_LANG_DATA_ACTION, ILangItem>(SET_LANG_DATA_ACTION, payload);

export const toggleIsOneClickTradingOnAction = () => createClearAction<typeof TOGGLE_IS_ONE_CLICK_TRADING_ON>(TOGGLE_IS_ONE_CLICK_TRADING_ON);
export const sendFacebookEventAction = (payload: Partial<ISendFacebookEventPayload>) => createAction<typeof SEND_FACEBOOK_EVENT_ACTION, Partial<ISendFacebookEventPayload>>(SEND_FACEBOOK_EVENT_ACTION, payload);

export const completeLeaderboardOnboardingSuccess = (payload?: unknown) => createClearAction<typeof COMPLETE_LEADERBOARD_ONBOARDING_SUCCESS>(COMPLETE_LEADERBOARD_ONBOARDING_SUCCESS, payload)